@if (!selectedContract) {
  <div class="row m-3">
    <div class="col-12 col-md-6 col-lg-4 search-bar">
      <input
        [formControl]="searchControl"
        [placeholder]="'SearchContract' | translate"
        class="form-control"
        type="search"
      />
    </div>
  </div>

  @for (contract of contracts.content | paginate: paginationConfig; track contract.number) {
    <div
      (click)="selectContract(contract, $event)"
      class="contract card border border-2 rounded m-3 p-4 cursor-pointer"
    >
      <app-my-contracts-header [contract]="contract" />

      <div class="row">
        <div class="col-12">
          <div class="row mb-n2">
            <h5 class="col-12 align-center">{{ 'CurrentMonth' | translate: contract.currentMonth }}</h5>
            <div class="col-lg-4">
              <app-graph [height]="'200px'" [data]="contract.requestsData" />
            </div>
            <div class="col-lg-4">
              <app-graph [height]="'200px'" [data]="contract.bandwidthData" />
            </div>
            <div class="col-lg-4">
              <app-graph [height]="'200px'" [data]="contract.activeSiteData" />
            </div>
          </div>
        </div>
      </div>
    </div>
  } @empty {
    @if (!loading) {
      <div class="m-3 text-muted">{{ 'NoContractFound' | translate }}</div>
    }
  }

  <div class="d-flex justify-content-center m-3">
    <pagination-controls
      (pageChange)="onPageChange($event)"
      [maxSize]="7"
      [nextLabel]="'Next' | translate"
      [previousLabel]="'Previous' | translate"
      id="contracts"
    />
  </div>
}

@if (selectedContract) {
  <app-contract-detail [(contract)]="selectedContract" />
}
